import {isNil} from "lodash";

export default {

    props: {
        modelValue: {},
    },

    emits: ['update:modelValue'],

    inject: {
        hasError: {
            default: () => false
        }
    },

    methods: {
        mainElement() {
            return this.$el;
        },
        focus() {
            this.mainElement().focus();
        },
        hasFocus() {
            return document.activeElement === this.mainElement();
        }
    },

    computed: {
        hasValue() {
            return !isNil(this.modelValue) && this.modelValue !== '';
        },
        model: {
            get() {
                return this.hasValue ? this.modelValue : null;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        }
    }
}
